import { getLabel } from "../../../../hooks/use-labels";
import { STATUS_GROUPS } from "../../../../features/orders/orderStatus";

export const orderTabs = [
  {
    key: STATUS_GROUPS.PENDING,
    label: getLabel("pendingLabel"),
  },
  {
    key: STATUS_GROUPS.PROCESSING,
    label: getLabel("processingLabel"),
  },
  {
    key: STATUS_GROUPS.PAST,
    label: getLabel("pastLabel"),
  },
];

export const orderPageSize = (width) => (width >= 1400 ? 9 : 8);

export const formatTabCount = (count) =>
  count < 10 ? `0${count}` : String(count);

export const formatOrderNumber = (orderNumber) =>
  `${getLabel("orderNoLabel")} ${orderNumber}`;

export const emptyCopy = {
  [STATUS_GROUPS.PENDING]: {
    heading: "No Orders Yet",
    body: "You haven't placed any orders yet.",
  },
  [STATUS_GROUPS.PROCESSING]: {
    heading: "Nothing in progress",
    body: "Nothing is on its way right now.",
  },
  [STATUS_GROUPS.PAST]: {
    heading: "No past orders",
    body: "Delivered, cancelled and refunded orders will appear here.",
  },
};

export const errorCopy = {
  502: {
    heading: "Server Unavailable",
    body: "The server is temporarily unavailable. Please try again.",
  },
  403: {
    heading: "Access Denied",
    body: "You don't have permission to view these orders.",
  },
  network: {
    heading: "Connection Problem",
    body: "We couldn't load your orders. Check your connection and try again.",
  },
};

export const supplierChipLabel = ({ loadedCount, subOrderCount, missingCount }) =>
  missingCount > 0
    ? `${loadedCount} of ${subOrderCount} suppliers`
    : `${subOrderCount} suppliers`;

export const splitNote = (missingCount) =>
  missingCount === 1
    ? "1 more supplier order from this purchase is in another tab"
    : `${missingCount} more supplier orders from this purchase are in another tab`;
